module.exports = __webpack_public_path__ + "img/steem.855d4357.svg";